export const UNKNOWN_USER_ALERT = "UNKNOWN_USER_ALERT_TYPE";
export const ERROR_USER_ALERT = "ERROR_USER_ALERT_TYPE";
export const INFO_USER_ALERT = "INFO_USER_ALERT_TYPE";